import React from 'react';
import './home.css';

const Home = ({ employee }) => {
  return (
    <div className="home-container">
      <div className="home-card shadow text-center">
        <div className="home-icon mb-3">
          <i className="bi bi-person-circle fs-1 text-primary"></i>
        </div>
        <h2 className="home-title">Welcome... {employee.name}!</h2>
        <p className="home-role">Role: {employee.role}</p>
      </div>
    </div>
  );
};

export default Home;
